// extracted by mini-css-extract-plugin
module.exports = {"style":{"fontFamily":"'Source Serif 4', 'Source Serif 4 Fallback'"},"className":"__className_002f55"};